export const paymentMethods = [
  {
    logo: '../../../assets/img/mock/paymentMethods/logo-visa.png',
  },
  {
    logo: '../../../assets/img/mock/paymentMethods/logo-mastercard.png',
  },
  {
    logo: '../../../assets/img/mock/paymentMethods/logo-amex.png',
  },
  {
    logo: '../../../assets/img/mock/paymentMethods/logo-discover.png',
  },
  // {
  //   logo: '../../../assets/img/mock/paymentMethods/logo-apple-pay.png',
  // },
  // {
  //   logo: '../../../assets/img/mock/paymentMethods/logo-google-pay.png',
  // },
  // {
  //   logo: '../../../assets/img/mock/paymentMethods/logo-paypal.png',
  // },
];
